import { useCallback, useEffect, useRef } from "react";
import useInputObject from "../../../hooks/useInputObject";

// export const config.Value.ENLARGE_RATIO = 3;
// export const WIDTH = 160;
// export const HEIGHT = 32;
// export const SHOW_WIDTH = WIDTH * config.Value.ENLARGE_RATIO;
// export const SHOW_HEIGHT = HEIGHT * config.Value.ENLARGE_RATIO;
// export const STROKE_WIDTH = 1;

const useCanvas = () => {
  const config = useInputObject({
    WIDTH: 160,
    HEIGHT: 32,
    STROKE_WIDTH: 1,
    ENLARGE_RATIO: 3,
  });

  const mainCanvasRef = useRef(null);
  const hiddenCanvasRef = useRef(null);
  const drawingRef = useRef(false);
  const positionRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const ctx = mainCanvasRef.current.getContext("2d");
    ctx.fillStyle = "white";
    ctx.fillRect(
      0,
      0,
      config.Value.WIDTH * config.Value.ENLARGE_RATIO,
      config.Value.HEIGHT * config.Value.ENLARGE_RATIO
    );
    ctx.strokeStyle = "black";
    ctx.lineWidth = config.Value.ENLARGE_RATIO * config.Value.STROKE_WIDTH;
  }, [config.Value]);

  const getCoordinates = useCallback((event) => {
    const rect = mainCanvasRef.current.getBoundingClientRect();
    if (event.touches && event.touches.length > 0) {
      return {
        x: event.touches[0].clientX - rect.left,
        y: event.touches[0].clientY - rect.top,
      };
    } else {
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    }
  }, []);

  const startDrawing = useCallback(
    (event) => {
      event.stopPropagation();
      positionRef.current = getCoordinates(event);
      drawingRef.current = true;
    },
    [getCoordinates]
  );

  const draw = useCallback((newPoint) => {
    const ctx = mainCanvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(positionRef.current.x, positionRef.current.y);
    ctx.lineTo(newPoint.x, newPoint.y);
    ctx.stroke();
    positionRef.current = newPoint;
  }, []);

  const stopDrawing = useCallback(() => {
    drawingRef.current = false;
  }, []);

  const clearCanvas = useCallback(() => {
    const ctx = mainCanvasRef.current.getContext("2d");
    const hiddenCtx = hiddenCanvasRef.current.getContext("2d");
    ctx.clearRect(
      0,
      0,
      config.Value.WIDTH * config.Value.ENLARGE_RATIO,
      config.Value.HEIGHT * config.Value.ENLARGE_RATIO
    );
    ctx.fillStyle = "white";
    ctx.fillRect(
      0,
      0,
      config.Value.WIDTH * config.Value.ENLARGE_RATIO,
      config.Value.HEIGHT * config.Value.ENLARGE_RATIO
    );
    hiddenCtx.clearRect(
      0,
      0,
      config.Value.WIDTH * config.Value.ENLARGE_RATIO,
      config.Value.HEIGHT * config.Value.ENLARGE_RATIO
    );
  }, [config.Value]);

  return {
    mainCanvasRef,
    hiddenCanvasRef,
    clearCanvas,
    startDrawing,
    draw,
    stopDrawing,
    config,
  };
};

export default useCanvas;
